<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <div
    v-if="isVisible"
    :style="{ paddingRight: $vuetify.breakpoint.xsOnly ? 0 : '400px' }"
    class="checkout-container"
  >
    <!-- NOTE: 自動延長バナーを出すときは、バナー側でヘッダー分を空ける。
         下のvending-historiesは同じ分をpaddingで空けているため、両方効くと二重にずれる -->
    <auto-extension-countdown
      :table-id="tableId"
      :expire-at="expireAt"
      :auto-extension-enabled="autoExtensionEnabled"
      :auto-extension-course-name="autoExtensionCourseName"
      :notice-minutes="autoExtensionNoticeMinutes"
      class="pa-2"
      :style="{ marginTop: `${headerHeight}px` }"
      @update:visible="isAutoExtensionCountdownVisible = $event"
      @updated:table="$emit('updated:table', $event)"
    />

    <!-- NOTE: :is-editingに&& isDrawerOpenも渡しているのはモバイル対応（渡さないと目玉アイコンが点灯したままになる） -->
    <vending-histories
      :customer-count="customerCount"
      :table-id="tableId"
      :hall-id="hallId"
      :start-at="startAt"
      :subtotal="isEditingVendingHistories ? '?' : subtotal"
      :discount-fee="discountFee"
      :service-fee="isEditingVendingHistories ? '?' : serviceFee"
      :total="isEditingVendingHistories ? '?' : total - discountFee"
      :paid-in-advance-amount="paidInAdvanceAmount"
      :total-deposit-amount="totalDepositAmount"
      :deposits="deposits"
      :is-editing="isEditingVendingHistories && isDrawerOpen"
      :table-name="tableName"
      :style="{ paddingTop: isAutoExtensionCountdownVisible ? '0px' : `${headerHeight}px` }"
      class="h-full"
      @eye:opened="editVendingHistories($event)"
      @eye:closed="cancelEditingVendingHistories"
      @order="orderFromVendingHistory($event)"
    >
      <!-- NOTE 注文履歴追加 start -->
      <!-- (伝票詳細の注文追加でも、再注文でも使ってる) -->
      <template #below-items>
        <v-overlay
          :value="isEditingVendingHistories"
          @click.native="cancelEditingVendingHistories"
        />

        <v-card class="d-flex align-center justify-center py-10">
          <v-dialog
            v-model="isOrdering"
            width="400"
            scrollable
          >
            <template #activator="{ on, attrs }">
              <v-btn
                fab
                icon
                large
                :ripple="false"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>
                  {{ icons.mdiPlus }}
                </v-icon>
              </v-btn>
            </template>

            <v-card
              class="py-4"
              :height="'100%'"
            >
              <v-card-text>
                <!-- eslint-disable vue/v-on-event-hyphenation -->
                <order-card
                  v-for="(vendingHistoryTemp, vendingHistoryTempIdx) in vendingHistoriesTemp"
                  :key="`vendingHistoriesTemp[${vendingHistoryTempIdx}]`"
                  v-model="vendingHistoryTemp.value"
                  :vendibles="vendibles"
                  :users="users"
                  :size="vendingHistoryTemp.size"
                  class="mb-4"
                  :hide-persistence-report="!isCourseVendingHistory(vendingHistoryTemp.value)"
                  @update:vendibleId="vendingHistoryTemp.value.vendibleId = $event"
                  @update:vendibleType="vendingHistoryTemp.value.vendibleType = $event"
                  @update:isNonExistVendible="vendingHistoryTemp.value.isNonExistVendible = $event"
                  @update:vendibleName="vendingHistoryTemp.value.vendibleName = $event"
                  @update:sellingPrice="vendingHistoryTemp.value.sellingPrice = $event"
                  @update:taxCharge="vendingHistoryTemp.value.taxCharge = $event"
                  @update:vendingContributionsAttributes="vendingHistoryTemp.value.vendingContributionsAttributes = $event"
                  @update:isArbitraryVendingContribution="vendingHistoryTemp.isArbitraryVendingContribution = $event"
                  @update:vendibleRecipientsAttributes="vendingHistoryTemp.value.vendibleRecipientsAttributes = $event"
                  @update:vendingHistoryCustomersAttributes="vendingHistoryTemp.value.vendingHistoryCustomersAttributes = $event"
                  @update:size="vendingHistoryTemp.size = $event"
                  @update:isPaidInAdvance="vendingHistoryTemp.value.isPaidInAdvance = $event"
                  @update:freeBack="vendingHistoryTemp.value.freeBack = $event"
                  @remove="removeVendingHistoryTempByIndex(vendingHistoryTempIdx)"
                />

                <v-card
                  elevation="0"
                  class="d-flex flex-column align-center justify-center"
                >
                  <v-text-field
                    :value="`¥${currentTotal.toLocaleString()}`"
                    readonly
                    hide-details
                    disabled
                    class="right-input font-weight-bold px-2 pb-4 w-full"
                  >
                    <template #prepend-inner>
                      <span class="text-sm">
                        現在の合計支払額
                      </span>
                    </template>
                  </v-text-field>

                  <total-display
                    :subtotal="estimatedSubtotal"
                    :tax="estimatedServiceFee"
                    :discount-fee="discountFee"
                    :processing-fee="processingFee"
                    :total="estimatedTotal"
                    :paid-in-advance-amount="estimatedPaidInAdvanceAmount"
                    :title="'注文後'"
                    :subtotal-msg="'小計（合計）'"
                    :tax-msg="'税サ等（合計）'"
                    :total-msg="'合計支払額'"
                    class="mb-4 px-2"
                  />

                  <div class="w-full d-flex justify-space-around align-center px-5">
                    <confirm-required-button
                      :is-confirmed="isShow ? isConfirmed.updateVendingHistories : true"
                      :is-valid="isValidToSubmit"
                      :is-submitting="isSubmitting"
                      :btn-message="'注文確定'"
                      :cancelable="true"
                      :already-confirmed="!isShow"
                      @confirmed="isConfirmed.updateVendingHistories = $event"
                      @cancel="isOrdering = false"
                      @clicked="isShow ? updateVendingHistories() : createVendingHistories()"
                    />
                  </div>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </template>
      <!-- NOTE 注文履歴追加 end -->
    </vending-histories>

    <v-navigation-drawer
      v-show="isDrawerOpen"
      app
      right
      stateless
      temporary
      permanent
      hide-overlay
      :width="drawerWidth"
      style="padding-left: 1px"
    >
      <!-- NOTE: padding-left: 1pxはv-tabsで左のoutlineが隠れないようにするため -->
      <v-card elevation="0">
        <v-card-text
          class="pb-16 mb-8"
          :style="{ paddingTop: `${headerHeight + 16}px`}"
        >
          <div v-if="!isEditingVendingHistories">
            <div
              v-if="isShow"
              class="text-sm text--secondary my-4 px-2 d-flex align-center"
            >
              発行日時:
              <v-spacer />
              {{ dateTime(receipt.attributes.createdAt) }}
            </div>

            <!-- NOTE: お会計 start -->
            <div class="payment-summary">
              <v-text-field
                :value="`¥${currentTotal.toLocaleString()}`"
                readonly
                hide-details
                class="right-input text-xl font-weight-semibold px-2"
              >
                <template #prepend-inner>
                  <span class="text-base text-no-wrap">
                    合計支払額
                  </span>
                </template>
              </v-text-field>

              <v-alert
                v-if="!isTotalReady"
                :type="totalFetchState === 'failed' ? 'error' : 'info'"
                dense
                text
                class="mx-2"
              >
                <div class="d-flex align-center">
                  <span>{{ totalFetchState === 'failed' ? '合計金額を取得できませんでした' : '合計金額を取得中です' }}</span>
                  <v-spacer />
                  <v-btn
                    small
                    outlined
                    :color="totalFetchState === 'failed' ? 'error' : 'info'"
                    @click="refreshTotalWithCharge"
                  >
                    再取得
                  </v-btn>
                </div>
              </v-alert>

              <total-display
                :subtotal="subtotal"
                :tax="serviceFee"
                :charge-amount="chargeAmount"
                :charge-msg="chargeName || 'チャージ'"
                :discount-fee="discountFee"
                :processing-fee="processingFee"
                :total="currentTotal"
                class="mb-12 pt-1 px-2"
              />
            </div>

            <div
              v-for="(payment, paymentIdx) in paymentsAttributes"
              :id="`payment-${paymentIdx}`"
              :key="`paymentsAttributes[${paymentIdx}]`"
              :class="payment._destroy ? '_destroy-color' : ''"
              class="mb-5"
            >
              <!-- NOTE: 入力欄は常に「元金」。会計手数料ON時は元金から手数料と請求額を導出して直下に表示する -->
              <v-text-field
                v-model.number="payment.baseAmount"
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                :label="paymentsAttributes.length > 1 ? `お預かり${paymentIdx+1}` : 'お預かり'"
                outlined
                hide-details
                prefix="¥"
                class="payment-input"
                @input="onBaseAmountInput(paymentIdx)"
                @change="onBaseAmountChange(paymentIdx)"
              >
                <template #append>
                  <v-icon
                    :class="['payment-icon', 'append-icon']"
                    @click="addPaymentAttributes"
                  >
                    {{ icons.mdiPlus }}
                  </v-icon>
                </template>
                <template #prepend>
                  <v-icon
                    v-if="paymentsAttributes.length > 1"
                    :class="['payment-icon', 'prepend-icon']"
                    @click="removePaymentAttributes(paymentIdx)"
                  >
                    {{ icons.mdiCloseCircleOutline }}
                  </v-icon>
                </template>
              </v-text-field>

              <div
                v-if="payment.isFractionAdjustment && !payment._destroy && Number(payment.baseAmount) > 0"
                class="payment-fee-note"
              >
                <span>会計手数料 {{ formatFeeDelta(payment.processingFee) }}</span>
                <span class="payment-fee-note__charge">ご請求 ¥{{ paymentAmountOf(payment).toLocaleString() }}</span>
              </div>

              <div class="d-flex justify-space-between align-center">
                <!-- NOTE: お釣りからお支払い金額を自動入力するボタン -->
                <v-btn
                  :ripple="false"
                  color="primary"
                  max-width="48"
                  min-width="48"
                  :disabled="change >= 0 || payment._destroy"
                  :class="paymentsAttributes.length > 1 ? 'ml-7' : ''"
                  class="payment-max-btn"
                  @click="setPaymentMaxHandler(payment, paymentIdx)"
                >
                  MAX
                </v-btn>
                <div class="d-flex align-center">
                  <v-switch
                    v-if="payment.paymentMethod === 'card'"
                    v-model="payment.isFractionAdjustment"
                    :disabled="!(Number(payment.baseAmount) > 0)"
                    messages="会計手数料"
                    dense
                    class="mb-2 mt-0 fraction-adjustment-switch"
                    @change="fractionAdjustmentHandler(payment, paymentIdx)"
                  />

                  <v-btn-toggle
                    v-model="payment.paymentMethod"
                    mandatory
                    color="primary"
                    dense
                    group
                  >
                    <v-btn
                      v-for="method in paymentMethods"
                      :key="method.value"
                      :value="method.value"
                      :disabled="payment._destroy"
                      :ripple="false"
                      class="vertical-btn-text"
                      :class="`payment-method-btn-${method.value}`"
                      @click="setPaymentMethodHandler(payment, method.value, paymentIdx)"
                    >
                      <v-icon small>{{ method.icon }}</v-icon>
                      <span class="text-xs">{{ method.name }}</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>
            </div>

            <v-expansion-panels
              v-model="balanceReceivableExpansionOpener"
              class="balance-receivable-container"
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="py-0 px-2 balance-receivable-header">
                  <div class="d-flex align-center">
                    <v-spacer />
                    <v-icon left>{{ icons.mdiCalendarAlert }}</v-icon>
                    <span>売掛</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-for="(balanceReceivable, balanceReceivableIdx) in balanceReceivablesAttributes"
                  :id="`balance-receivable-${balanceReceivableIdx}`"
                  :key="`balanceReceivablesAttributes[${balanceReceivableIdx}]`"
                  :class="balanceReceivable._destroy ? '_destroy-color' : ''"
                >
                  <v-text-field
                    v-model.number="balanceReceivable.amount"
                    type="number"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    outlined
                    hide-details
                    prefix="¥"
                    :append-icon="icons.mdiPlus"
                    :prepend-icon="(balanceReceivablesAttributes.length > 1 || isShow) ? icons.mdiCloseCircleOutline : ''"
                    class="balance-receivable-field"
                    @click:append="addBalanceReceivablesAttributes"
                    @click:prepend="removeBalanceReceivablesAttributes(balanceReceivableIdx)"
                  />
                  <v-textarea
                    v-model="balanceReceivable.note"
                    placeholder="ノート"
                    rows="3"
                    :prepend-icon="icons.mdiCommentQuoteOutline"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <div
              v-if="deposits && deposits.length > 0"
              class="px-2 mb-4"
            >
              <div class="text-caption font-weight-bold mb-1">
                登録済みお預かりメモ
              </div>
              <div
                v-for="deposit in deposits"
                :key="`deposit-check-${deposit.id}`"
                class="d-flex justify-space-between text-caption"
              >
                <span>
                  <v-chip
                    x-small
                    :color="deposit.paymentMethod === 'cash' ? 'success' : 'info'"
                    dark
                  >
                    {{ deposit.paymentMethod === 'cash' ? '現金' : 'カード' }}
                  </v-chip>
                  {{ deposit.userName }}
                </span>
                <span class="font-weight-medium">
                  ¥{{ deposit.amount.toLocaleString() }}
                </span>
              </div>
              <v-divider class="my-1" />
              <div class="d-flex justify-space-between text-caption font-weight-bold">
                <span>預かり金合計</span>
                <span>¥{{ totalDepositAmount.toLocaleString() }}</span>
              </div>
              <div
                class="d-flex justify-space-between text-caption font-weight-bold mt-1"
                :class="{ 'red--text': (currentTotal - totalDepositAmount) > 0 }"
              >
                <span>{{ (currentTotal - totalDepositAmount) < 0 ? '返金額' : '未収金' }}</span>
                <span>¥{{ Math.abs(currentTotal - totalDepositAmount).toLocaleString() }}</span>
              </div>
            </div>

            <v-text-field
              :value="`¥${totalPaymentAmount.toLocaleString()}`"
              readonly
              hide-details
              class="right-input text-xl font-weight-semibold px-2 mb-8"
            >
              <template #prepend-inner>
                <span class="text-base text-no-wrap">
                  お預かり合計
                </span>
              </template>
            </v-text-field>

            <v-text-field
              v-model.number="discountFee"
              type="number"
              inputmode="numeric"
              pattern="[0-9]*"
              label="値引き"
              :min="0"
              :rules="[rules.discount]"
              outlined
              hide-details
              prefix="¥"
              class="discount-field"
            />

            <v-text-field
              :value="`¥${change.toLocaleString()}`"
              readonly
              hide-details
              :error="!isValidChange"
              class="mt-8 mb-6 right-input text-xl font-weight-semibold px-2"
            >
              <template #prepend-inner>
                <span class="text-base">
                  お釣り
                </span>
              </template>
            </v-text-field>

            <v-subheader>
              <v-icon left>
                {{ icons.mdiPrinterPos }}
              </v-icon>
              レシート
            </v-subheader>
            <v-divider />

            <div
              v-if="!isShow"
              class="receipt-print-config"
            >
              <v-tooltip
                top
                :disabled="isReceiptPrinterConnected"
              >
                <template #activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-checkbox
                      v-model="withPrintSettlementSlip"
                      :disabled="!isReceiptPrinterConnected"
                      :ripple="false"
                      label="レシートを印刷"
                      dense
                      hide-details
                      class="mt-4 ms-4"
                    />

                    <v-checkbox
                      v-model="withPrintReceiptSlip"
                      :disabled="!isReceiptPrinterConnected"
                      :ripple="false"
                      label="領収書を印刷"
                      dense
                      hide-details
                      class="mt-4 ms-4"
                    />
                    <div
                      v-if="withPrintReceiptSlip"
                      class="ms-4 mt-2"
                    >
                      <v-btn-toggle
                        v-model="receiptIssueMode"
                        mandatory
                        dense
                        color="primary"
                        class="mb-2"
                        style="display: flex"
                      >
                        <v-btn
                          value="lump"
                          x-small
                          style="flex: 1"
                        >
                          一括（1枚）
                        </v-btn>
                        <v-btn
                          value="split"
                          x-small
                          style="flex: 1"
                        >
                          分割 {{ splitRows.length || customerCount }}
                        </v-btn>
                      </v-btn-toggle>
                      <div v-if="receiptIssueMode === 'lump'">
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <v-divider />
                              詳細設定
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card flat>
                                <v-card-text>
                                  <receipt-slip-setting
                                    :customer-name="receiptSlipAdvancedOptions.customerName"
                                    :receipt-note="receiptSlipAdvancedOptions.receiptNote"
                                    :date="receiptSlipAdvancedOptions.date"
                                    :receipt-note-presets="receiptNotePresets"
                                    @update:customerName="receiptSlipAdvancedOptions.customerName = $event"
                                    @update:receiptNote="receiptSlipAdvancedOptions.receiptNote = $event"
                                    @update:date="receiptSlipAdvancedOptions.date = $event"
                                  />
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                        <Preview
                          :slip-svg="receiptSlipSvg"
                          class="mt-2"
                        />
                      </div>
                      <split-receipt-section
                        v-else
                        v-model="splitRows"
                        :real-total="currentTotal"
                        :subtotal="Number(subtotal) || 0"
                        :service-fee="Number(serviceFee) || 0"
                        :processing-fee="Number(processingFee) || 0"
                        :discount-fee="Number(discountFee) || 0"
                        :customer-count="Number(customerCount) || 1"
                        :payments="paymentsWithAmount"
                        :customers="customers"
                        :receipt-note-presets="receiptNotePresets"
                        :slip-base-options="slipPrintBaseOptions"
                      />
                    </div>

                    <v-checkbox
                      v-model="withPrintDebtConfirmationPrint"
                      :disabled="!balanceReceivableAmount || !(balanceReceivableAmount > 0)"
                      :ripple="false"
                      label="債務確認書を印刷"
                      dense
                      hide-details
                      class="mt-4 ms-4"
                    />
                  </span>
                </template>

                <span v-if="!isReceiptPrinterConnected">
                  機能を有効にするためはプリンタとの接続が必要です
                </span>
              </v-tooltip>

              <v-checkbox
                v-model="withQRcode"
                label="電子レシートを共有"
                :ripple="false"
                dense
                hide-details
                class="mt-4 ms-4"
              />

              <v-checkbox
                v-model="withReceiptDetails"
                label="明細を印字"
                :ripple="false"
                dense
                hide-details
                class="mt-6 ms-4"
              />

              <Preview
                :slip-svg="settlementSlipSvg"
                class="mt-4"
              />
            </div>

            <div
              v-else
              class="mt-4"
            >
              <print-btn
                v-if="isShow"
                subject="レシート"
                :print="printSettlementSlip"
                :block="true"
              >
                <template #append>
                  <v-checkbox
                    v-model="withReceiptDetails"
                    label="明細を印字"
                    dense
                    hide-details
                    :ripple="false"
                    class="mt-4 ms-4"
                  />

                  <v-alert
                    v-if="isSdpSlipPrintEnabled"
                    dense
                    text
                    color="warning"
                    class="mt-2 mb-0 text-caption"
                  >
                    2回目以降の印刷では紙面に【再印字】と再印字日時が入ります（プレビューには表示されません）
                  </v-alert>

                  <Preview
                    :slip-svg="settlementSlipSvg"
                    class="mt-1"
                  />

                  <div class="mt-1">
                    <QrCode
                      v-if="receipt.attributes.receiptImages && receipt.attributes.receiptImages.length > 0"
                      :urls="receipt.attributes.receiptImages"
                      class="mt-1"
                    />
                    <v-btn
                      v-else
                      text
                      color="primary"
                      :ripple="false"
                      @click="submitReceipt"
                    >
                      <v-icon left>
                        {{ icons.mdiQrcode }}
                      </v-icon>
                      電子レシートを発行
                    </v-btn>
                  </div>
                </template>
              </print-btn>

              <div v-if="isShow">
                <v-subheader class="mt-8">
                  <v-icon left>
                    {{ icons.mdiPrinterPos }}
                  </v-icon>
                  領収書
                </v-subheader>
                <v-divider class="mb-5" />
                <v-alert
                  v-if="isSdpSlipPrintEnabled"
                  dense
                  text
                  color="warning"
                  class="mb-4 text-caption"
                >
                  発行済みと同じ内容（宛名・金額・但し書き）を再度印刷すると、紙面に【再発行】が入ります（プレビューには表示されません）
                </v-alert>
                <v-btn-toggle
                  v-model="receiptIssueMode"
                  mandatory
                  dense
                  color="primary"
                  class="mb-4"
                  style="display: flex"
                >
                  <v-btn
                    value="lump"
                    small
                    style="flex: 1"
                  >
                    一括（1枚）
                  </v-btn>
                  <v-btn
                    value="split"
                    small
                    style="flex: 1"
                  >
                    分割 {{ splitRows.length || customerCount }}
                  </v-btn>
                </v-btn-toggle>
                <div v-if="receiptIssueMode === 'lump'">
                  <print-btn
                    subject="領収書"
                    :print="japAssReceiptPrint"
                    :block="true"
                    class="mt-2"
                  />
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <v-divider />
                        詳細設定
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card flat>
                          <v-card-text>
                            <receipt-slip-setting
                              :customer-name="receiptSlipAdvancedOptions.customerName"
                              :receipt-note="receiptSlipAdvancedOptions.receiptNote"
                              :date="receiptSlipAdvancedOptions.date"
                              :receipt-note-presets="receiptNotePresets"
                              @update:customerName="receiptSlipAdvancedOptions.customerName = $event"
                              @update:receiptNote="receiptSlipAdvancedOptions.receiptNote = $event"
                              @update:date="receiptSlipAdvancedOptions.date = $event"
                            />
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <Preview
                    :slip-svg="receiptSlipSvg"
                    class="mt-2"
                  />
                </div>
                <split-receipt-section
                  v-else
                  v-model="splitRows"
                  :real-total="currentTotal"
                  :subtotal="Number(subtotal) || 0"
                  :service-fee="Number(serviceFee) || 0"
                  :processing-fee="Number(processingFee) || 0"
                  :discount-fee="Number(discountFee) || 0"
                  :customer-count="Number(customerCount) || 1"
                  :payments="paymentsWithAmount"
                  :customers="customers"
                  :receipt-note-presets="receiptNotePresets"
                  :slip-base-options="slipPrintBaseOptions"
                  :print-row-fn="reprintSplitRow"
                />

                <div v-if="balanceReceivableAmount && balanceReceivableAmount > 0">
                  <v-subheader class="mt-8">
                    <v-icon left>
                      {{ icons.mdiPrinterPos }}
                    </v-icon>
                    その他
                  </v-subheader>
                  <v-divider class="mb-5" />
                  <print-btn
                    subject="債務確認書"
                    :print="printDebtConfirmationSlip"
                    :block="true"
                    class="mt-8"
                  />
                </div>
              </div>

              <v-divider class="mt-10" />
              <v-dialog
                v-model="isDeleting"
                width="400"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="error"
                    block
                    class="mt-4"
                    :ripple="false"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>
                      {{ icons.mdiTrashCanOutline }}
                    </v-icon>削除
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    削除の確認
                  </v-card-title>

                  <v-card-text>
                    削除を実行してもよろしいですか（卓を含めたこの伝票に関連する全てのデータも削除します。）
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="error"
                      :loading="isSubmitting"
                      :disabled="isSubmitting"
                      :ripple="false"
                      @click="deleteReceipt"
                    >
                      同意の上で削除
                    </v-btn>
                    <v-btn
                      text
                      :ripple="false"
                      @click="isDeleting = false"
                    >
                      キャンセル
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <v-app-bar
              bottom
              prominent
              outlined
              fixed
              height="76"
            >
              <div class="d-flex flex-column align-center w-full h-full px-5">
                <v-spacer />
                <confirm-required-button
                  :is-confirmed="isConfirmed.submitReceipt"
                  :is-valid="isValidToCheckout"
                  :is-submitting="isSubmittingReceipt"
                  :btn-message="isShow ? '更新' : '会計'"
                  class="checkout-btn"
                  @confirmed="isConfirmed.submitReceipt = $event"
                  @clicked="submitReceipt"
                />
                <v-spacer />
              </div>
            </v-app-bar>
          </div>
          <!-- NOTE: お会計 end -->

          <!-- NOTE: 注文履歴編集 start -->
          <div v-else>
            <div class="d-flex">
              <v-spacer />
              <v-switch
                v-model="isEditingVendingHistories"
                label="編集中"
                hide-details
                loading="primary"
                @click="cancelEditingVendingHistories"
              >
              </v-switch>
            </div>

            <v-card
              v-if="vendingHistoriesTemp.length > 0"
              elevation="0"
              class="mb-10"
            >
              <!-- eslint-disable vue/v-on-event-hyphenation -->
              <order-card
                v-for="(vendingHistoryTemp, vendingHistoryTempIdx) in vendingHistoriesTemp"
                :key="`vendingHistoriesTemp[${vendingHistoryTempIdx}]`"
                v-model="vendingHistoryTemp.value"
                :vendibles="vendibles"
                :users="users"
                :size="vendingHistoryTemp.size"
                :sizable="false"
                :ordered-at="vendingHistoryTemp.orderedAt"
                class="mt-3 mb-8"
                :hide-persistence-report="isEditingVendingHistories"
                @update:vendibleId="vendingHistoryTemp.value.vendibleId = $event"
                @update:vendibleType="vendingHistoryTemp.value.vendibleType = $event"
                @update:isNonExistVendible="vendingHistoryTemp.value.isNonExistVendible = $event"
                @update:vendibleName="vendingHistoryTemp.value.vendibleName = $event"
                @update:sellingPrice="vendingHistoryTemp.value.sellingPrice = $event"
                @update:taxCharge="vendingHistoryTemp.value.taxCharge = $event"
                @update:vendingContributionsAttributes="vendingHistoryTemp.value.vendingContributionsAttributes = $event"
                @update:_destroy="vendingHistoryTemp.value._destroy = $event"
                @update:isArbitraryVendingContribution="vendingHistoryTemp.isArbitraryVendingContribution = $event"
                @update:vendibleRecipientsAttributes="vendingHistoryTemp.value.vendibleRecipientsAttributes = $event"
                @update:vendingHistoryCustomersAttributes="vendingHistoryTemp.value.vendingHistoryCustomersAttributes = $event"
                @update:size="vendingHistoryTemp.size = $event"
                @update:isPaidInAdvance="vendingHistoryTemp.value.isPaidInAdvance = $event"
                @update:freeBack="vendingHistoryTemp.value.freeBack = $event"
                @remove="removeVendingHistoryTempByIndex(vendingHistoryTempIdx)"
              />
            </v-card>

            <v-text-field
              :value="`¥${currentTotal.toLocaleString()}`"
              readonly
              hide-details
              disabled
              class="right-input font-weight-bold px-2 pb-4"
            >
              <template #prepend-inner>
                <span class="text-sm">
                  現在の合計支払額
                </span>
              </template>
            </v-text-field>
            <total-display
              :subtotal="estimatedSubtotal"
              :tax="estimatedServiceFee"
              :discount-fee="discountFee"
              :processing-fee="processingFee"
              :total="estimatedTotal"
              :paid-in-advance-amount="estimatedPaidInAdvanceAmount"
              :title="'更新後'"
              :subtotal-msg="'小計（合計）'"
              :tax-msg="'税サ等（合計）'"
              :total-msg="'合計支払額'"
              class="mb-4 px-2"
            />

            <v-app-bar
              bottom
              outlined
              fixed
              height="76"
            >
              <div class="d-flex flex-column align-center w-full h-full px-5">
                <v-spacer />
                <confirm-required-button
                  :is-confirmed="isConfirmed.updateVendingHistories"
                  :is-valid="isValidToSubmit"
                  :is-submitting="isSubmitting"
                  :btn-message="'更新'"
                  :cancelable="true"
                  @confirmed="isConfirmed.updateVendingHistories = $event"
                  @cancel="cancelEditingVendingHistories"
                  @clicked="updateVendingHistories"
                />
                <v-spacer />
              </div>
            </v-app-bar>
          </div>
        <!-- NOTE: 注文履歴編集 end -->
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  inject,
  provide,
  watch,
  getCurrentInstance,
  onBeforeUnmount,
} from '@vue/composition-api'
import { useVModel } from '@vueuse/core'
import {
  sumBy,
  includes,
  each,
  map,
  cloneDeep,
  reject,
  isEqual,
  update,
  filter,
  chain,
  debounce,
} from 'lodash'
import {
  mdiPrinterPos,
  mdiCurrencyJpy,
  mdiCreditCard,
  mdiPlus,
  mdiCloseCircleOutline,
  mdiCommentQuoteOutline,
  mdiTrashCanOutline,
  mdiSubdirectoryArrowRight,
  mdiQrcode,
  mdiCalendarAlert,
} from '@mdi/js'
import { getVuetify, useRouter } from '@core/utils'
import { useReceiptSlipPrint, useSettlementSlipPrint, useDebtConfirmationSlipPrint } from '@yonarezi/yonarezi3.slip-print'
import { removePortFromIpAddress } from '@/utils/removePortFromIpAddress'
import { wrapPrinterReceive } from '@/utils/sentryReportPrinterError'
import useVendingHistory from '@/views/composable/useVendingHistory'
import useDateFormat from '@/views/composable/useDateFormat'
import useCurrentData from '@/views/composable/useCurrentData'
import useSlipFooterItems from '@/views/composable/useSlipFooterItems'
import useSdpSlipPrint from '@/views/composable/useSdpSlipPrint'
import useCashDrawerKick from '@/views/composable/useCashDrawerKick'
import TableApi from '@/api/waiter/Table'
import {
  paymentAmount,
  remainingBaseAmount,
  shouldAutoApply,
  toPaymentsPayload,
  restorePaymentRows,
  legacyProcessingFeeOf,
} from '@/utils/checkout/paymentFee'
import VendingHistoryApi from '@/api/waiter/VendingHistory'
import ReceiptApi from '@/api/waiter/Receipt'
import ReceiptSlipPrintHistoryApi from '@/api/v2/audit/ReceiptSlipPrintHistory'
import OrderCard from '@/views/components/table/OrderCard/OrderCard.vue'
import ConfirmRequiredButton from '@/views/components/util/ConfirmRequiredButton.vue'
import TotalDisplay from '@/views/components/util/TotalDisplay.vue'
import PrintBtn from '@/views/components/util/PrintBtn.vue'
import Preview from '@/views/components/printer/Preview.vue'
import QrCode from '@/views/components/printer/QrCode.vue'
import VendingHistories from './VendingHistories.vue'
import ReceiptSlipSetting from './ReceiptSlipSetting.vue'
import SplitReceiptSection from './SplitReceiptSection.vue'
import AutoExtensionCountdown from '@/views/components/table/AutoExtensionCountdown.vue'
import { AUTO_EXTENSION_NOTICE_MINUTES } from '@/views/composable/useAutoExtensionCountdown'

export default {
  components: {
    VendingHistories,
    OrderCard,
    ConfirmRequiredButton,
    TotalDisplay,
    PrintBtn,
    Preview,
    QrCode,
    ReceiptSlipSetting,
    SplitReceiptSection,
    AutoExtensionCountdown,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    isCheckDrawerOpen: {
      type: Boolean,
      default: true,
    },
    headerHeight: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      default: 46,
    },
    drawerWidth: {
      type: [Number, String],
      default: 400,
    },
    tableId: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
    tableName: {
      type: String,
      required: true,
      default: '',
    },
    customerCount: {
      type: [Number, String],
      required: true,
    },
    startAt: {
      type: String,
      required: true,
    },
    expireAt: {
      type: String,
      default: null,
    },
    autoExtensionEnabled: {
      type: Boolean,
      default: false,
    },
    autoExtensionCourseName: {
      type: String,
      default: null,
    },
    sequenceNumber: {
      type: Number,
      required: false,
      default: null,
    },
    receipt: {
      type: Object,
      default: () => {},
    },
    totalDepositAmount: {
      type: [Number, String],
      default: 0,
    },
    deposits: {
      type: Array,
      default: () => [],
    },
    customers: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy
    const $vuetify = getVuetify()
    const { router } = useRouter()

    const isDrawerOpen = useVModel(props, 'isCheckDrawerOpen')

    const users = inject('users', [])
    const vendibles = inject('vendibles', [])
    const isReceiptPrinterConnected = inject('isReceiptPrinterConnected', false)
    const printer = inject('printer', null)
    const referringHistories = inject('referringHistories', [])
    const receiptNotePresets = inject('receiptNotePresets', [])
    const fetchOperationRateStats = inject('fetchOperationRateStats', () => {})
    const hallId = inject('hallId', ref(null))
    // 親(フロア/ホール画面)が持つホールの会計設定。データ画面経由では提供されない
    const hallCheckoutConfig = inject('hallCheckoutConfig', null)

    const isConfirmed = reactive({
      submitReceipt: false,
      updateVendingHistories: false,
    })
    const isEditingVendingHistories = ref(false)
    const isSubmitting = ref(false)
    const isSubmittingReceipt = ref(false)
    const isOrdering = ref(false)
    const isDeleting = ref(false)
    const total = ref(0) // 丸め処理済みの大計
    // 合計(total)の取得状態。'pending' | 'ready' | 'failed'
    // total はサーバ応答で初めて確定するため、ready になるまで会計を確定させない
    // (応答前に確定すると total=0 の伝票が保存される)
    const totalFetchState = ref('pending')
    const chargeAmount = ref(0) // チャージ額(税サに合算して表示・保存する)
    const chargeName = ref('') // 適用されたチャージ設定の表示名
    const discountFee = ref(0) // 値引金額
    const paymentsAttributes = ref([])
    // NOTE: 旧伝票(2026-04以前: 支払行の手数料が0で伝票側だけ手数料あり)の手数料。行には帰属させず別項で保持し、
    // 行の手数料を計算し直したら0にする(再保存で旧値を勝手に書き換えないため)
    const legacyProcessingFee = ref(0)
    // NOTE: 会計手数料の合計は支払行の手数料(+旧伝票の別項)から一意に決まる(画面全体で別系統の計算はしない)
    const processingFee = computed(() => legacyProcessingFee.value + sumBy(paymentsAttributes.value, o => {
      // eslint-disable-next-line no-underscore-dangle
      return o._destroy ? 0 : (Number(o.processingFee) || 0)
    }))
    // NOTE: 子コンポーネント(領収書分割など)向けに、請求額(元金+手数料)を amount として持たせた支払行
    const paymentsWithAmount = computed(() => paymentsAttributes.value.map(row => ({ ...row, amount: paymentAmount(row) })))
    // NOTE: ホール設定「カード選択時に会計手数料を自動適用」(率が未設定なら false)
    const processingFeeAutoApplicable = ref(false)
    // NOTE: 手数料再計算APIの応答待ち件数(0になるまで会計を確定させない)
    const pendingFeeCalcCount = ref(0)
    const balanceReceivablesAttributes = ref([])
    const balanceReceivableExpansionOpener = ref()
    const estimatedTotal = ref(0)

    const withPrintSettlementSlip = ref(true)
    const withPrintReceiptSlip = ref(false)
    const withReceiptDetails = ref(true)
    // 電子レシート共有はプリンタ接続状態に関わらず常にOFFが既定。任意でONにしたときだけ共有する
    const withQRcode = ref(false)
    const withPrintDebtConfirmationPrint = ref(false)
    // 紐づく顧客が1人のときだけ、その顧客の領収書宛名をデフォルトとしてセットする
    // 複数人/未紐付けの場合は宛名なし（運用上どの顧客向けか曖昧になるため）
    const defaultCustomerName = props.customers.length === 1
      ? (props.customers[0].receiptAddressee || '')
      : ''
    const receiptSlipAdvancedOptions = reactive({
      customerName: defaultCustomerName,
      // 但し書きはプリセットに0番目をデフォとして詳細設定を開かずともセットするため
      receiptNote: receiptNotePresets.value.length > 0 ? receiptNotePresets.value[0].attributes.content : '',
      date: new Date(),
      receiptSlipNumber: props.receipt?.id ? props.receipt.id : '',
    })

    // 領収書発行モード: 'lump' (一括1枚) | 'split' (分割N枚)
    const receiptIssueMode = ref('lump')
    const splitRows = ref([])

    const isPickingIssueDate = ref(false)

    const rules = {
      discount: value => value !== '',
    }

    const paymentMethods = [
      {
        value: 'cash',
        name: '現金',
        icon: mdiCurrencyJpy,
      },
      {
        value: 'card',
        name: 'カード',
        icon: mdiCreditCard,
      },
    ]

    // NOTE VendingHistoriesのコンポーネントでvending_historiesをinjectしてる
    // Hall配下ではそれがTableShowDrawerからprovideされてる
    // このreceiptVendingHistoriesは伝票の編集で使う（receiptがvendingHistoriesを持ってる)
    // このreceiptVendingHistoriesに代入後,provideすることでVendingHistoriesのコンポーネントに渡す
    //  + useVendingHistoryのvendingHistoriesにもinjectされる
    const receiptVendingHistories = ref([])
    // NOTE: receipt自体がvendingHistories持ってたらそっち使ってもらえるよう
    if (props.receipt?.attributes?.vendingHistories?.data?.length > 0) {
      receiptVendingHistories.value = [...props.receipt.attributes.vendingHistories.data]
      // TODO: 既存のホールの絡みでvendingHistoriesをinjectする感じになっててキモイ。
      // ホールでは現在進行形の卓が表示されているのでreceiptがない一方、データ>伝票画面での編集時でもこのcompが使われていてこじれてる
      provide('vendingHistories', receiptVendingHistories)
      // NOTE: useVendingHistoryのvendingHistoriesにもinjectされるためには、それより上にprovideの記述をしなければならい
    }
    const {
      vendingHistories,
      vendingHistoriesTemp,
      addVendingHistoryTemp,
      removeVendingHistoryTempByIndex,
      resetVendingHistoriesTemp,
      isValidToSubmit,
      vendingHistoriesToSubmit,
      setVendingContributionsAttributes,
    } = useVendingHistory()

    const { currentClub, currentUser } = useCurrentData()
    const { dateTime, hhmm } = useDateFormat()

    // 自動延長の予告用: 発火は終了の1分前固定（終了通知設定とは独立）
    const autoExtensionNoticeMinutes = AUTO_EXTENSION_NOTICE_MINUTES
    // 予告バナーの表示有無。表示中はバナー側がヘッダー分を空けるので明細側のpaddingは外す
    const isAutoExtensionCountdownVisible = ref(false)

    // NOTE 保存済みの販売履歴から編集対象の販売履歴を除いたもの（編集モードでなければ保存済みのものだけを返す）
    const vendingHistoriesWithoutUpdateTargets = computed(() => {
      const updateTargetIds = map(vendingHistoriesToSubmit.value, obj => Number(obj.id))

      return reject(vendingHistories.value, obj => {
        return includes(updateTargetIds, Number(obj.id))
      })
    })

    // NOTE: 前金フラグのついた販売履歴
    const vendingHistoriesWithoutUpdateTargetsPaidInAdvance = computed(() => {
      return chain(vendingHistoriesWithoutUpdateTargets.value)
        .filter('attributes.isPaidInAdvance')
        .value()
    })

    // NOTE: 前金フラグのついた販売履歴(編集対象)
    const vendingHistoriesTempPaidInAdvance = computed(() => {
      return chain(vendingHistoriesTemp.value)
        .filter('value.isPaidInAdvance')
        .value()
    })

    // NOTE: 小計
    const subtotal = computed(() => {
      return sumBy(vendingHistoriesWithoutUpdateTargets.value, obj => +obj.attributes.sellingPrice)
    })

    // NOTE: 小計(前金フラグのついた支払い済)
    const subtotalPaidInAdvance = computed(() => {
      return sumBy(vendingHistoriesWithoutUpdateTargetsPaidInAdvance.value, obj => +obj.attributes.sellingPrice)
    })

    // NOTE: 小計(更新後)(概算用)
    const estimatedSubtotal = computed(() => {
      const subtotalForUpdateTargets = sumBy(vendingHistoriesTemp.value, obj => {
        // eslint-disable-next-line no-underscore-dangle
        if (obj.value._destroy) return 0

        return +obj.value.sellingPrice * obj.size
      })

      // NOTE: 編集対象の小計の合計と,それを除いた販売履歴の小計の合計を合算
      return subtotalForUpdateTargets + subtotal.value
    })

    // NOTE: 小計(更新後)(概算用)(前金フラグがついて支払い済みになる)
    const estimatedSubtotalPaidInAdvance = computed(() => {
      const subtotalPaidInAdvanceForUpdateTargets = sumBy(vendingHistoriesTempPaidInAdvance.value, obj => {
        // eslint-disable-next-line no-underscore-dangle
        if (obj.value._destroy) return 0

        return +obj.value.sellingPrice * obj.size
      })

      // NOTE: 編集対象の小計の合計と,それを除いた販売履歴の小計の合計を合算
      return subtotalPaidInAdvanceForUpdateTargets + subtotalPaidInAdvance.value
    })

    // NOTE: 税サ等(シングルチャージはサーバ計算値を税サに合算する。レシート・BR定数と同じ扱い)
    const serviceFee = computed(() => {
      if (total.value <= 0) return 0

      return sumBy(vendingHistoriesWithoutUpdateTargets.value, obj => {
        // NOTE: tax込み/カットは除外
        if (includes(['cut', 'included'], obj.attributes.taxCharge)) return 0

        return +obj.attributes.taxPrice
      }) + chargeAmount.value
    })

    // NOTE: 税サ等(前金フラグのついた支払い済)
    const serviceFeePaidInAdvance = computed(() => {
      if (total.value <= 0) return 0

      return sumBy(vendingHistoriesWithoutUpdateTargetsPaidInAdvance.value, obj => {
        // NOTE: tax込み/カットは除外
        if (includes(['cut', 'included'], obj.attributes.taxCharge)) return 0

        return +obj.attributes.taxPrice
      })
    })

    // NOTE: 税サ等(更新後)(概算用)
    const estimatedServiceFee = computed(() => {
      const serviceFeeForUpdateTargets = sumBy(vendingHistoriesTemp.value, obj => {
        // eslint-disable-next-line no-underscore-dangle
        if (obj.value._destroy) return 0

        return +obj.estimatedTaxPrice * obj.size
      })

      return serviceFeeForUpdateTargets + serviceFee.value
    })

    // NOTE: 税サ等(更新後)(概算用)(前金フラグがついて支払い済みになる)
    const estimatedServiceFeePaidInAdvance = computed(() => {
      const serviceFeeForUpdateTargetsPaidInAdvance = sumBy(vendingHistoriesTempPaidInAdvance.value, obj => {
        // eslint-disable-next-line no-underscore-dangle
        if (obj.value._destroy) return 0

        return +obj.estimatedTaxPrice * obj.size
      })

      return serviceFeeForUpdateTargetsPaidInAdvance + serviceFeePaidInAdvance.value
    })

    // NOTE: 前金
    const paidInAdvanceAmount = computed(() => {
      return subtotalPaidInAdvance.value + serviceFeePaidInAdvance.value
    })

    // NOTE: 前金(更新後)(概算用)
    const estimatedPaidInAdvanceAmount = computed(() => {
      return estimatedSubtotalPaidInAdvance.value + estimatedServiceFeePaidInAdvance.value
    })

    // NOTE: total(丸め処理済みの最終的な合計金額) + 会計手数料 - 値引き金額
    const currentTotal = computed(() => {
      return Number(total.value) + Number(processingFee.value) - Number(discountFee.value)
    })

    // NOTE: 未収金（合計支払額 - 預かり金合計）
    const unpaidAmount = computed(() => {
      return currentTotal.value - Number(props.totalDepositAmount || 0)
    })

    // NOTE: 合計お預かり金額
    const totalPaymentAmount = computed(() => {
      const totalPaymentAttributesAmount = sumBy(paymentsAttributes.value, obj => {
        // eslint-disable-next-line no-underscore-dangle
        return obj._destroy ? 0 : paymentAmount(obj)
      })
      const totalBalanceReceivablesAttributes = sumBy(balanceReceivablesAttributes.value, obj => {
        // eslint-disable-next-line no-underscore-dangle
        return obj._destroy ? 0 : Number(obj.amount)
      })

      return totalPaymentAttributesAmount + totalBalanceReceivablesAttributes
    })

    // NOTE: お釣り（預かり金込み）
    // NOTE: お釣り計算（預かり金は含めない。手数料が店舗ごとに異なるため、スタッフが手動でお預かり欄に入力する）
    const change = computed(() => {
      const result = (currentTotal.value - totalPaymentAmount.value) * -1

      // -0を出さない
      return 1 / result === -Infinity ? 0 : result
    })

    const isValidDiscountFee = () => discountFee.value !== ''
    const isValidChange = () => change.value >= 0

    const receiptAttributes = computed(() => {
      return {
        total: total.value,
        discountFee: discountFee.value,
        processingFee: processingFee.value,
        serviceFee: serviceFee.value,
        subtotal: subtotal.value,
        paymentsAttributes: toPaymentsPayload(paymentsAttributes.value),
        balanceReceivablesAttributes: filter(balanceReceivablesAttributes.value, o => o.amount > 0),
      }
    })

    const isShow = computed(() => {
      return props.receipt?.id && props.receipt?.attributes
    })

    // NOTE: 合計が取得済みか(会計済み伝票の表示・更新時は凍結値を使うので常に取得済み扱い)
    const isTotalReady = computed(() => isShow.value || totalFetchState.value === 'ready')

    // NOTE: お釣りがマイナス（預かり金が足りていない）じゃないか？合計は取得済みか？
    // 手数料の再計算が応答待ちの間は確定させない(古い手数料で保存しないため)
    const isValidToCheckout = computed(() => {
      return isValidChange() && isValidDiscountFee() && isTotalReady.value && pendingFeeCalcCount.value === 0
    })

    const paymentAmounts = computed(() => {
      let cash = 0
      let card = 0
      each(paymentsAttributes.value, attr => {
        const { paymentMethod, _destroy: isToDelete } = attr
        const amount = paymentAmount(attr)
        if (!isToDelete) {
          if (paymentMethod === 'cash') cash += amount
          if (paymentMethod === 'card') card += amount
        }
      })

      return {
        cash,
        card,
      }
    })

    // NOTE: 売掛など支払行以外の支払合計(未収残額の算出に使う)
    const balanceReceivablePaid = () => sumBy(balanceReceivablesAttributes.value, o => {
      // eslint-disable-next-line no-underscore-dangle
      return o._destroy ? 0 : Number(o.amount) || 0
    })

    // NOTE: 指定行を除いた未収残額(元金ベース)
    const remainingBaseAmountFor = paymentIdx => remainingBaseAmount({
      total: total.value,
      discountFee: discountFee.value,
      payments: paymentsAttributes.value,
      index: paymentIdx,
      extraPaid: balanceReceivablePaid(),
    })

    // NOTE: 手数料再計算の行ごとの状態。reactiveな行には持たせない(再描画やdeep watchを誘発しないため)
    const feeRequestSeqs = new WeakMap() // 応答順序逆転・無効化した要求の応答を捨てる連番
    const feeCalculatedBases = new WeakMap() // 直前に計算した元金(同じ元金の再リクエストを省く)
    const autoAppliedRows = new WeakSet() // カード選択で自動ONした行(再タップで店員のOFFを覆さない)
    const rowAt = paymentIdx => paymentsAttributes.value[paymentIdx]
    const invalidateFeeRequest = row => {
      const seq = (feeRequestSeqs.get(row) || 0) + 1
      feeRequestSeqs.set(row, seq)

      return seq
    }

    // NOTE: 支払行の会計手数料を元金から再計算する(唯一の計算経路)。
    // API は { amount: 請求額, processingFee } を返す。元金は入力値のまま保ち、請求額との差を手数料にする(端数切り捨て設定なら負になる)
    const recalcPaymentFee = async row => {
      if (!row) return
      const target = row // eslint(no-param-reassign)回避: 行オブジェクトへの書き込みはこの参照経由
      const seq = invalidateFeeRequest(row) // 早期returnでも進めて、飛んでいる応答が後から手数料を書き戻さないようにする
      const base = Number(row.baseAmount) || 0
      if (!row.isFractionAdjustment || base <= 0) {
        target.processingFee = 0
        feeCalculatedBases.delete(row)

        return
      }
      if (feeCalculatedBases.get(row) === base) return // 同じ元金で計算済み(デバウンス後のblurによる二重要求を省く)

      legacyProcessingFee.value = 0 // 行の手数料を計算し直したら旧伝票の手数料は引き継がない
      pendingFeeCalcCount.value += 1
      try {
        const res = await TableApi.calcFractionAdjustment({ tableId: props.tableId, price: base })
        if (feeRequestSeqs.get(row) !== seq) return // 古い/無効化された応答は捨てる

        const amount = Number(res?.data?.amount)
        // DBの請求額はintegerなので、no_rounding設定で小数が返っても保存値と一致するよう切り捨てる
        target.processingFee = Number.isFinite(amount) ? Math.trunc(amount) - base : 0
        feeCalculatedBases.set(row, base)
      } catch (e) {
        if (feeRequestSeqs.get(row) !== seq) return

        target.isFractionAdjustment = false
        target.processingFee = 0
        feeCalculatedBases.delete(row)
        vm.$toast.error('会計手数料を計算できませんでした')
      } finally {
        pendingFeeCalcCount.value -= 1
      }
    }

    // NOTE: 入力中は行ごとに少し待ってから再計算(連打でAPIを叩かない)。確定(フォーカスアウト/Enter)時は待たずに反映
    const feeDebouncers = new WeakMap()
    const activeFeeDebouncers = new Set()
    const debouncedRecalcFor = row => {
      let fn = feeDebouncers.get(row)
      if (!fn) {
        fn = debounce(() => recalcPaymentFee(row), 300)
        feeDebouncers.set(row, fn)
        activeFeeDebouncers.add(fn)
      }

      return fn
    }
    const onBaseAmountInput = paymentIdx => {
      const row = rowAt(paymentIdx)
      if (row) debouncedRecalcFor(row)()
    }
    const onBaseAmountChange = paymentIdx => {
      const row = rowAt(paymentIdx)
      if (!row) return undefined
      debouncedRecalcFor(row).cancel()

      return recalcPaymentFee(row)
    }
    onBeforeUnmount(() => activeFeeDebouncers.forEach(fn => fn.cancel()))

    const setPaymentMaxHandler = async (payment, paymentIdx) => {
      const row = rowAt(paymentIdx)
      if (!row) return
      // 特定の支払い項目のみを更新: 未収残額を元金にする(手数料ONなら手数料を再計算)
      row.baseAmount = remainingBaseAmountFor(paymentIdx)
      await recalcPaymentFee(row)
    }

    const fractionAdjustmentHandler = async (payment, paymentIdx) => {
      // NOTE: スイッチOFFは手数料0(元金はそのまま)。ONは元金から再計算
      await recalcPaymentFee(rowAt(paymentIdx))
    }

    const setPaymentMethodHandler = async (payment, paymentMethod, paymentIdx) => {
      // indexからpaymentを取得
      const row = rowAt(paymentIdx)
      if (!row) return
      if (paymentMethod !== 'card') {
        // NOTE: カード以外(現金など)に戻したら手数料は外す(飛んでいる再計算の応答も無効化)。元金はそのまま残す
        row.isFractionAdjustment = false
        autoAppliedRows.delete(row)
        await recalcPaymentFee(row)

        return
      }

      // NOTE: ホール設定で自動適用ONならスイッチを自動ON。一度自動ONした行はカードの再タップで再適用しない(店員がOFFにした判断を覆さない)
      if (!shouldAutoApply({ autoApplicable: processingFeeAutoApplicable.value, paymentMethod })) return
      if (autoAppliedRows.has(row)) return
      autoAppliedRows.add(row)
      row.isFractionAdjustment = true // 元金が未入力でもONにしておき、入力・MAX・大計取得後の補完で手数料を計算する
      if (!(Number(row.baseAmount) > 0)) {
        row.baseAmount = remainingBaseAmountFor(paymentIdx)
      }
      await recalcPaymentFee(row)
    }

    // NOTE: 大計の取得前にカードを選んだ行は元金が入らないため、取得できたら未収残額を補完して手数料を計算する
    watch(isTotalReady, ready => {
      if (!ready) return
      paymentsAttributes.value.forEach((row, idx) => {
        if (row.paymentMethod !== 'card' || !row.isFractionAdjustment || !autoAppliedRows.has(row)) return
        if (Number(row.baseAmount) > 0) return
        paymentsAttributes.value[idx].baseAmount = remainingBaseAmountFor(idx)
        recalcPaymentFee(row)
      })
    })

    const formatFeeDelta = fee => {
      const n = Number(fee) || 0

      return `${n < 0 ? '−' : '+'}¥${Math.abs(n).toLocaleString()}`
    }

    const addPaymentAttributes = ({
      id = null,
      baseAmount = 0,
      paymentMethod = 'cash',
      _destroy = false,
      processingFee: fee = 0,
      isFractionAdjustment = false,
    }) => {
      paymentsAttributes.value.push({
        id,
        baseAmount,
        paymentMethod,
        _destroy,
        processingFee: fee,
        isFractionAdjustment,
      })
    }

    const removePaymentAttributes = paymentIdx => {
      const removeTarget = paymentsAttributes.value.splice(paymentIdx, 1)[0]

      // NOTE: 保存済みのものを削除の場合_destroyをtrueにして元いた場所に返す
      if (removeTarget.id) {
        // eslint-disable-next-line no-underscore-dangle
        removeTarget._destroy = !removeTarget._destroy
        paymentsAttributes.value.splice(paymentIdx, 0, removeTarget)
      }

      return removeTarget
    }

    const addBalanceReceivablesAttributes = ({
      id = null,
      amount = 0,
      note = '',
      _destroy = false,
    }) => {
      balanceReceivablesAttributes.value.push({
        id,
        amount,
        note,
        _destroy,
      })
    }

    const removeBalanceReceivablesAttributes = balanceReceivableIdx => {
      const removeTarget = balanceReceivablesAttributes.value.splice(balanceReceivableIdx, 1)[0]

      // NOTE: 保存済みのものを削除の場合_destroyをtrueにして元いた場所に返す
      if (removeTarget.id) {
        // eslint-disable-next-line no-underscore-dangle
        removeTarget._destroy = !removeTarget._destroy
        balanceReceivablesAttributes.value.splice(balanceReceivableIdx, 0, removeTarget)
      }

      return removeTarget
    }

    const addVendingHistoryTempFromData = ({ isNew = false, actualData }) => {
      each(actualData, vendingHistory => {
        const {
          vendibleId,
          vendibleType,
          taxCharge,
          sellingPrice,
          isNonExistVendible,
          createdAt,
          isPaidInAdvance,
          freeBack,
          persistenceReport,
        } = vendingHistory.attributes
        // NOTE: vendibleNameはisNonExistVendible用の属性、vendibleId持つ場合は不必要
        const vendibleName = vendibleId ? undefined : vendingHistory.attributes.vendibleName

        const vendingContributionsAttributes = map(vendingHistory.attributes.vendingContributions.data, data => {
          const { userId, vendingHistoryId, ratio } = data.attributes

          return {
            id: isNew ? null : data.id,
            userId,
            vendingHistoryId,
            ratio,
            _destroy: null,
          }
        })

        const vendibleRecipientsAttributes = map(vendingHistory.attributes.vendibleRecipients.data, data => {
          const { userId, vendingHistoryId, ratio } = data.attributes

          return {
            id: isNew ? null : data.id,
            userId,
            vendingHistoryId,
            ratio,
            _destroy: null,
          }
        })

        const vendingHistoryCustomersAttributes = map(vendingHistory.attributes.vendingHistoryCustomers?.data || [], data => {
          const { customerId, vendingHistoryId: vhId } = data.attributes

          return {
            id: isNew ? null : data.id,
            customerId,
            vendingHistoryId: vhId,
            _destroy: null,
          }
        })

        addVendingHistoryTemp({
          id: isNew ? null : vendingHistory.id,
          vendibleId,
          vendibleType,
          taxCharge,
          sellingPrice,
          isNonExistVendible,
          vendibleName,
          vendingContributionsAttributes,
          vendibleRecipientsAttributes,
          vendingHistoryCustomersAttributes,
          size: 1,
          isArbitraryVendingContribution: true,
          orderedAt: createdAt,
          isPaidInAdvance,
          freeBack,
          persistenceReport,
        })
      })
    }

    const editVendingHistories = actualData => {
      isEditingVendingHistories.value = true
      isDrawerOpen.value = true
      addVendingHistoryTempFromData({ isNew: false, actualData })
    }

    const cancelEditingVendingHistories = () => {
      resetVendingHistoriesTemp()

      if ($vuetify.breakpoint.xsOnly) {
        isDrawerOpen.value = false
      }

      isEditingVendingHistories.value = false
    }

    const updateVendingHistories = async () => {
      isSubmitting.value = true

      if (isValidToSubmit.value && isConfirmed.updateVendingHistories) {
        const res = await VendingHistoryApi.updateVendingHistories({
          tableId: props.tableId,
          vendingHistories: vendingHistoriesToSubmit.value,
        })

        if (res?.data) {
          emit('updated:vending-histories', res.data.vendingHistories.data)
          emit('updated:table', res.data.table.data)

          vm.$toast.success('注文履歴を更新しました')

          if (isShow.value) {
            emit('updated:receipt', res.data.table.data.attributes.receipt.data)
            receiptVendingHistories.value = [...res.data.vendingHistories.data]
            vm.$toast.success('伝票を更新しました')
          }

          fetchOperationRateStats()
        }
      }

      isSubmitting.value = false
      isOrdering.value = false
      cancelEditingVendingHistories()
    }

    const isCourseVendingHistory = vendingHistory => {
      return vendingHistory.vendibleType === 'Course'
    }

    const createVendingHistories = async () => {
      isSubmitting.value = true

      if (isValidToSubmit.value) {
        const res = await VendingHistoryApi.createVendingHistories({
          tableId: props.tableId,
          vendingHistories: vendingHistoriesToSubmit.value,
        })

        if (res?.status === 200) {
          emit('updated:vending-histories', res.data.vendingHistories.data)
          emit('updated:table', res.data.table.data)
          vm.$toast.success('注文しました')
        }
      }

      isSubmitting.value = false
      isOrdering.value = false
      cancelEditingVendingHistories()
    }

    const calcTotal = async (price = null) => {
      const res = await TableApi.calcTotal({
        tableId: props.tableId,
        price,
      })

      return res?.data
    }

    // チャージ込みの合計と内訳を取得して total / chargeAmount / chargeName を更新する
    // 注文編集などで再取得が重なったとき、古い応答が後から届いて total を上書きしないよう最新のみ反映する
    let totalFetchSeq = 0
    const refreshTotalWithCharge = async () => {
      totalFetchSeq += 1
      const seq = totalFetchSeq
      totalFetchState.value = 'pending'
      try {
        const res = await TableApi.calcTotal({
          tableId: props.tableId,
          withBreakdown: true,
        })
        if (seq !== totalFetchSeq) return

        const fetchedTotal = res?.data?.total
        if (fetchedTotal === undefined || fetchedTotal === null) throw new Error('calc_total returned no total')

        total.value = Number(fetchedTotal) || 0
        chargeAmount.value = Number(res?.data?.chargeAmount ?? 0) || 0
        chargeName.value = res?.data?.chargeName || ''
        totalFetchState.value = 'ready'
      } catch (e) {
        if (seq !== totalFetchSeq) return

        totalFetchState.value = 'failed'
        console.error('Failed to fetch table total:', e)
        vm.$toast.error('合計金額を取得できませんでした。「再取得」してから会計してください')
      }
    }

    const calcTax = async price => {
      const res = await TableApi.calcTax({
        tableId: props.tableId,
        price,
      })

      return res?.data
    }

    const resetCheckComp = () => {
      isDrawerOpen.value = true
      isConfirmed.submitReceipt = false
      isConfirmed.updateVendingHistories = false
      isEditingVendingHistories.value = false
      resetVendingHistoriesTemp()

      if (!isShow.value) {
        paymentsAttributes.value = []
        addPaymentAttributes({})

        balanceReceivablesAttributes.value = []
        balanceReceivableExpansionOpener.value = undefined
      }
    }

    const orderFromVendingHistory = actualData => {
      // NOTE: 再注文時に前金・フリーバックフラグは引き継がない(フリーバックは二重カウント防止)
      const dataToPass = {
        ...actualData[0],
        ...{
          attributes: {
            ...actualData[0].attributes,
            isPaidInAdvance: false,
            freeBack: false,
          },
        },
      }
      addVendingHistoryTempFromData({ isNew: true, actualData: [dataToPass] })
      isOrdering.value = true
    }

    const deleteReceipt = async () => {
      isSubmitting.value = true
      const res = await ReceiptApi.deleteReceipt(props.receipt.id)
      fetchOperationRateStats()

      if (res?.status === 200) emit('deleted')
      isSubmitting.value = false
    }

    // NOTE: to YONAREZI 3
    const slipPrintBaseOptions = computed(() => {
      return {
        ipAddress: removePortFromIpAddress(currentClub.value.printIpAddress),
        clubName: currentClub.value.name,
        invoiceNumber: currentClub.value.invoiceNumber,
        address: currentClub.value.address,
        tel: currentClub.value.telephoneNumber,
        customerCount: props.customerCount.toLocaleString(),
        tableCode: props.tableName,
        startAt: hhmm(props.startAt),
        isPrintSequenceNumber: currentClub.value.isPrintSequenceNumber,
        sequenceNumber: props.sequenceNumber,
        printer: printer.value,
        // 分割プレビューでも伝票No.を表示できるよう base に含める。
        // 通常の receiptSlipOptions では後段の ...receiptSlipAdvancedOptions が
        // 同値で上書きするため挙動は変わらない。
        receiptSlipNumber: receiptSlipAdvancedOptions.receiptSlipNumber,
      }
    })
    const { footerItems: receiptFooterItems, fetchFooterItems: fetchReceiptFooterItems } = useSlipFooterItems()
    const { footerItems: settlementFooterItems, fetchFooterItems: fetchSettlementFooterItems } = useSlipFooterItems()

    // 分割発行で行ごとの金額で物理印字するために、total を上書きできる ref。
    // null のときは currentTotal を採用 (従来挙動)。
    const receiptSlipTotalOverride = ref(null)
    const receiptSlipOptions = computed(() => {
      return {
        ...slipPrintBaseOptions.value,
        ...receiptSlipAdvancedOptions,
        total: receiptSlipTotalOverride.value ?? currentTotal.value,
        footerItems: receiptFooterItems.value,
      }
    })
    const balanceReceivableAmount = computed(() => {
      let balanceReceivablesAmount = 0
      balanceReceivablesAmount += sumBy(balanceReceivablesAttributes.value, o => Number(o.amount))

      return balanceReceivablesAmount
    })
    const settlementSlipOptions = computed(() => {
      return {
        ...slipPrintBaseOptions.value,
        referringHistories: referringHistories.value || [],
        referralAlias: currentClub.value.referralAlias,
        withOrderDetails: withReceiptDetails.value,
        // データ画面 → ReceiptShowDrawer 経由で開いたとき、inject('vendingHistories', []) の
        // デフォルトが素の配列で .value が undefined になり、slip-print 内部で
        // formatVendingHistoriesToOrderDetails(undefined).length が throw する pre-existing
        // バグへの安全フォールバック。
        vendingHistories: vendingHistories.value || [],
        nominationAlias: currentClub.value.nominationAlias,
        courseAlias: currentClub.value.courseAlias,
        subtotal: subtotal.value,
        // NOTE:
        // serviceFeeって名前だけど内容はtaxの合計金額
        // 会計手数料は印字せずに税サ等に組み込む
        tax: (serviceFee.value + processingFee.value),
        total: currentTotal.value,
        discountAmount: discountFee.value || null,
        cashPaymentAmount: paymentAmounts.value.cash,
        cardPaymentAmount: paymentAmounts.value.card,
        balanceReceivableAmount: balanceReceivableAmount.value,
        totalReceivedAmount: totalPaymentAmount.value,
        change: change.value,
        footerItems: settlementFooterItems.value,
      }
    })
    const debtConfirmationSlipOptions = computed(() => {
      return {
        ...slipPrintBaseOptions.value,
        balanceReceivableAmount: balanceReceivableAmount.value,
      }
    })
    const { send: sendReceiptSlip, onReceive: onReceiveReceiptSlipPrint, svg: receiptSlipSvg } = useReceiptSlipPrint(receiptSlipOptions)
    const { send: sendSettlementSlip, onReceive: onReceiveSettlementSlipPrint, svg: settlementSlipSvg } = useSettlementSlipPrint(settlementSlipOptions)

    const buildFooterContext = () => ({
      REAL_TOTAL: currentTotal.value,
      SUBTOTAL: subtotal.value,
      TOTAL: currentTotal.value,
      SERVICE_FEE: serviceFee.value,
      PROCESSING_FEE: processingFee.value,
      DISCOUNT_AMOUNT: discountFee.value,
      CASH_PAYMENT_AMOUNT: paymentAmounts.value.cash || 0,
      CARD_PAYMENT_AMOUNT: paymentAmounts.value.card || 0,
      CUSTOMER_COUNT: Number(props.customerCount) || 0,
    })

    const fetchFooterForSlip = async (fetchFn, slipType) => {
      await fetchFn({
        hallId: hallId.value,
        tableId: props.tableId,
        slipType,
        context: buildFooterContext(),
      })
    }

    // プレビューにもフッターを反映するため、setup時に事前取得
    fetchFooterForSlip(fetchReceiptFooterItems, 'receipt')
    fetchFooterForSlip(fetchSettlementFooterItems, 'settlement')

    // 金額変更時にフッターを再取得（プレビュー反映）
    watch(currentTotal, () => {
      fetchFooterForSlip(fetchReceiptFooterItems, 'receipt')
      fetchFooterForSlip(fetchSettlementFooterItems, 'settlement')
    })

    const { isSdpEnabled, requestPrint: requestSdpPrint } = useSdpSlipPrint({ toast: vm.$toast })

    // 再印字・再発行マークはSDP経路(サーバー組立)でのみ紙面に入る。
    // プレビューSVG(slip-printパッケージのクライアント描画)には反映されないため、
    // SDP有効店舗の再印刷導線に限り注記を表示する
    const isSdpSlipPrintEnabled = computed(() => isSdpEnabled())

    // Date / 'YYYY-MM-DD' 文字列 → サーバーに渡す日付文字列（ローカル日付。toISOStringはUTCずれするため使わない）
    const toDateString = value => {
      if (!value) return null
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return null

      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    }

    // 領収書のSDP印刷依頼inputs。withRowSlipOverrides による分割行の差し替えも
    // receiptSlipOptions 経由でそのまま反映される
    const sdpReceiptInputs = () => {
      const {
        customerName, date, receiptNote, total: slipTotal, receiptSlipNumber,
      } = receiptSlipOptions.value

      return {
        customer_name: customerName || '',
        receipt_note: receiptNote || '',
        issue_date: toDateString(date),
        receipt_slip_number: receiptSlipNumber ? String(receiptSlipNumber) : null,
        amount: slipTotal,
      }
    }

    const printReceiptSlip = async ({ reprint = false } = {}) => {
      // SDP有効店舗はサーバー経由で印刷（フッター評価・XML生成もサーバー側）。
      // reprint はサーバー(履歴API)の再発行判定結果で、紙面の【再発行】印字に使う
      if (isSdpEnabled()) {
        await requestSdpPrint({
          ticketType: 'receipt',
          receiptId: props.receipt?.id,
          inputs: { ...sdpReceiptInputs(), reprint },
        })

        return
      }

      await fetchFooterForSlip(fetchReceiptFooterItems, 'receipt')
      await sendReceiptSlip()
    }
    const printSettlementSlip = async () => {
      // 精算伝票は会計(Receipt)の存在が前提のため、receipt があるときのみSDP経路を使う
      if (isSdpEnabled() && props.receipt?.id) {
        await requestSdpPrint({
          ticketType: 'settlement',
          receiptId: props.receipt.id,
          inputs: { with_order_details: withReceiptDetails.value },
        })

        return
      }

      await fetchFooterForSlip(fetchSettlementFooterItems, 'settlement')
      await sendSettlementSlip()
    }
    const { send: sendDebtConfirmationSlip, onReceive: onReceiveDebtConfirmationSlipPrint } = useDebtConfirmationSlipPrint(debtConfirmationSlipOptions)
    const printDebtConfirmationSlip = async () => {
      if (isSdpEnabled()) {
        await requestSdpPrint({
          ticketType: 'debt_confirmation',
          inputs: { amount: balanceReceivableAmount.value },
        })

        return
      }

      await sendDebtConfirmationSlip()
    }
    const receiptPrinterContext = () => ({
      kind: 'receipt',
      ipAddress: removePortFromIpAddress(currentClub.value?.printIpAddress || ''),
      clubId: currentClub.value?.id,
    })
    const receiptPrinterContextWithToast = () => ({
      ...receiptPrinterContext(),
      printerName: 'レシートプリンタ',
      toast: vm.$toast,
    })

    // 現金支払いがある会計の確定時にキャッシュドロワーを開く(ブラウザ直結印刷の店舗用)。
    // SDP経路は submitReceipt 内で drawer_kick チケットを印刷依頼列に積むため、ここでは直結送信のみ使う
    const { kickDirect: kickCashDrawer } = useCashDrawerKick({ toast: vm.$toast })
    onReceiveReceiptSlipPrint.value = wrapPrinterReceive(null, {
      ...receiptPrinterContextWithToast(),
      slipKind: 'receipt-slip',
    })
    onReceiveSettlementSlipPrint.value = wrapPrinterReceive(null, {
      ...receiptPrinterContextWithToast(),
      slipKind: 'settlement',
    })
    onReceiveDebtConfirmationSlipPrint.value = wrapPrinterReceive(null, {
      ...receiptPrinterContextWithToast(),
      slipKind: 'debt-confirmation',
    })

    // 発行履歴を作成し、サーバーの再発行判定（同一会計・同一内容の2回目以降か）を返す
    const createReceiptSlipPrintHistory = async () => {
      const {
        customerName: to,
        date: issuedDate,
        receiptNote: note,
        total: amount,
      } = receiptSlipOptions.value
      const params = {
        receiptSlipPrintHistory: {
          to,
          issuedDate,
          note,
          amount,
          receiptId: props.receipt?.id,
          issuerId: currentUser.value.id,
        },
      }
      const res = await ReceiptSlipPrintHistoryApi.createReceiptSlipPrintHistory(params)

      return res?.data?.data?.reprint === true
    }

    // 履歴作成を先に確定してから印字する（再発行判定を紙面に反映するため直列化）。
    // 履歴の残らない印字を防ぐため、履歴作成に失敗したら印字しない
    const japAssReceiptPrint = async () => {
      let reprint = false
      try {
        reprint = await createReceiptSlipPrintHistory()
      } catch (e) {
        const serverMessage = e?.response?.data?.message
        const reason = (Array.isArray(serverMessage) ? serverMessage.join(' / ') : serverMessage) || e?.message
        vm.$toast.error(`領収書の発行履歴を作成できなかったため印刷を中止しました${reason ? `（${reason}）` : ''}`)

        return
      }
      await printReceiptSlip({ reprint })
    }

    // receiptSlipAdvancedOptions の宛名・但し書き・発行日と total override を
    // 一時的に行の値に切り替えてから action を実行し、finally で元に戻す。
    // 分割発行で行ごとに違う領収書を物理印字するために使う。
    const withRowSlipOverrides = async (row, action) => {
      const previous = {
        customerName: receiptSlipAdvancedOptions.customerName,
        receiptNote: receiptSlipAdvancedOptions.receiptNote,
        date: receiptSlipAdvancedOptions.date,
      }
      receiptSlipAdvancedOptions.customerName = row.to || ''
      receiptSlipAdvancedOptions.receiptNote = row.note || ''
      // 発行日が未選択 (空) の行は日付なしで印字する
      receiptSlipAdvancedOptions.date = row.issuedDate || undefined
      receiptSlipTotalOverride.value = Number(row.amount || 0)
      try {
        await action()
      } finally {
        receiptSlipAdvancedOptions.customerName = previous.customerName
        receiptSlipAdvancedOptions.receiptNote = previous.receiptNote
        receiptSlipAdvancedOptions.date = previous.date
        receiptSlipTotalOverride.value = null
      }
    }

    // 会計後の分割行から再印刷するときに使う。行の宛名・但し書き・発行日・金額で
    // 一度だけ印刷 + ReceiptSlipPrintHistory を作成する。
    const reprintSplitRow = row => withRowSlipOverrides(row, japAssReceiptPrint)

    const createSVGDisplayElement = async () => {
      const svgDOM = new DOMParser().parseFromString(settlementSlipSvg.value, 'image/svg+xml').documentElement

      svgDOM.style.width = '100%'
      svgDOM.style.background = 'white'
      svgDOM.style.color = 'black'
      const padding = 20
      const width = svgDOM.width.baseVal.value
      const height = svgDOM.height.baseVal.value
      // viewBoxを設定してSVG全体にパディングを追加
      svgDOM.setAttribute('viewBox', `-${padding} -${padding} ${width + 2 * padding} ${height + 2 * padding}`)
      svgDOM.style.width = `${width + 2 * padding}px`
      svgDOM.style.height = `${height + 2 * padding}px`

      return svgDOM
    }
    const svg2imageData = (svgElement, successCallback, errorCallback) => {
      const canvas = document.createElement('canvas')

      canvas.width = svgElement.width.baseVal.value
      canvas.height = svgElement.height.baseVal.value
      const ctx = canvas.getContext('2d')
      const image = new Image()
      image.onload = () => {
        ctx.drawImage(image, 0, 0, image.width, image.height)
        canvas.toBlob(blob => {
          successCallback(blob)
        })
      }
      image.onerror = e => {
        errorCallback(e)
      }
      const svgData = new XMLSerializer().serializeToString(svgElement)
      image.src = `data:image/svg+xml;charset=utf-8;base64,${btoa(unescape(encodeURIComponent(svgData)))}`
    }
    const submitReceipt = async () => {
      isSubmittingReceipt.value = true

      // 印刷予定のスリップフッターを ReceiptApi.createReceipt と並列で先行取得する。
      // 印刷直前に直列で fetch していた分のラウンドトリップを ReceiptApi.createReceipt の
      // 待ち時間に重ねることで、ユーザー体感の印刷遅延を削減する。
      // (手動再印刷ボタンが使う printReceiptSlip / printSettlementSlip 自体は今回変更しない)
      let footerPrefetchPromise = Promise.resolve()
      // SDP有効店舗はフッター評価もサーバー側で行うため、プリフェッチ不要
      if (isReceiptPrinterConnected.value && !isSdpEnabled()) {
        const tasks = []
        if (withPrintReceiptSlip.value) tasks.push(fetchFooterForSlip(fetchReceiptFooterItems, 'receipt'))
        if (withPrintSettlementSlip.value) tasks.push(fetchFooterForSlip(fetchSettlementFooterItems, 'settlement'))
        if (tasks.length > 0) footerPrefetchPromise = Promise.all(tasks)
      }

      // NOTE: ここで画像データを作成しそれぞれのapiに渡す
      // いずれの場合も新規作成データとする
      const receiptImage = await createSVGDisplayElement()
      const {
        customerName: to,
        date: issuedDate,
        receiptNote: note,
        total: amount,
      } = receiptSlipOptions.value

      // 分割モードでは splitRows の各行を receipt_slip_print_histories_attributes として
      // 一括登録する。ハードウェア印字は currentTotal で1枚だけ (sendReceiptSlip 制約)。
      const params = (receiptIssueMode.value === 'split' && splitRows.value.length > 0)
        ? splitRows.value.map(r => ({
          to: r.to || '',
          // 発行日が未選択 (空) の行は日付なしで保存する (issued_date は null 許容)
          issuedDate: r.issuedDate || null,
          note: r.note || '',
          amount: r.amount,
          issuerId: currentUser.value.id,
        }))
        : [{
          to,
          issuedDate,
          note,
          amount,
          issuerId: currentUser.value.id,
        }]

      // 作成後に削除
      svg2imageData(receiptImage, async blob => {
        try {
          if (isShow.value) {
            const res = await ReceiptApi.updateReceipt({
              id: props.receipt.id,
              receiptAttributes: {
                ...receiptAttributes.value,
                images: blob,
              },
            })

            if (res?.data?.data) {
              emit('updated:receipt', res.data.data)
              vm.$toast.success('伝票を更新しました')
            }
          } else {
            const res = await ReceiptApi.createReceipt({
              tableId: props.tableId,
              receiptAttributes: {
                ...receiptAttributes.value,
                images: blob,
                receiptSlipPrintHistoriesAttributes: (withPrintReceiptSlip.value ? params : {}),
              },
            })

            if (res?.data?.receipt?.data) {
              receiptSlipAdvancedOptions.receiptSlipNumber = res.data.receipt.data.id

              const newReceiptId = res.data.receipt.data.id
              const receipt = res.data.receipt.data
              // NOTE: 電子レシートを共有ONでなかったらreceiptImagesは空に
              if (!withQRcode.value) receipt.attributes.receiptImages = []

              // === レシートSDP: 会計確定と印刷を分離する ===
              // SDPは印刷完了まで最大30秒のチケット状態ポーリングが走る。これを await して
              // からチェックアウト(emit('checked'))すると、その間ずっと卓が一覧に残り続け、
              // ユーザーが戻ると同じ卓で再会計できてしまう(=二重会計バグ)。
              // そこで「会計確定(createReceipt成功)した時点で即チェックアウト」し、
              // 印刷依頼はバックグラウンドで非同期に投げる(成否トースト・再送一覧は従来通り)。
              if (isReceiptPrinterConnected.value && isSdpEnabled()) {
                // 印刷依頼inputsを先にスナップショットする。emit('checked') がドロワーを閉じ
                // Check.vue をリセット/アンマウントするため、印刷に必要な値は確定前に
                // プレーンオブジェクトとして確保しておく(以後リアクティブ状態に依存しない)。
                const sdpPrintRequests = []
                if (withPrintReceiptSlip.value) {
                  if (receiptIssueMode.value === 'split' && splitRows.value.length > 0) {
                    // 分割モード: 行ごとに宛名・金額・但し書きを切替えて inputs を確定する
                    // eslint-disable-next-line no-restricted-syntax
                    for (const row of splitRows.value) {
                      // withRowSlipOverrides 内で receiptSlipOptions が行の値に差し替わるので、
                      // その状態の sdpReceiptInputs() を同期的に取り出して確保する
                      // eslint-disable-next-line no-await-in-loop
                      await withRowSlipOverrides(row, () => {
                        sdpPrintRequests.push({ ticketType: 'receipt', receiptId: newReceiptId, inputs: sdpReceiptInputs() })

                        return Promise.resolve()
                      })
                    }
                  } else {
                    sdpPrintRequests.push({ ticketType: 'receipt', receiptId: newReceiptId, inputs: sdpReceiptInputs() })
                  }
                }
                if (withPrintSettlementSlip.value) {
                  sdpPrintRequests.push({
                    ticketType: 'settlement',
                    receiptId: newReceiptId,
                    inputs: { with_order_details: withReceiptDetails.value },
                  })
                }
                if (withPrintDebtConfirmationPrint.value) {
                  sdpPrintRequests.push({ ticketType: 'debt_confirmation', inputs: { amount: balanceReceivableAmount.value } })
                }
                // 現金支払いがある会計はキャッシュドロワーを開ける(印字なしのパルス専用チケット)。
                // 釣り銭対応のため伝票印刷より先に開けたいので先頭に入れる。
                // ドロワーの開閉はその場で分かるため完了ポーリング・成功トーストは省略する(watch: false)
                if (paymentAmounts.value.cash > 0) {
                  sdpPrintRequests.unshift({ ticketType: 'drawer_kick', watch: false })
                }

                // 会計確定 = 即チェックアウト。卓を一覧から外し、印刷完了を待たずに二重会計を防ぐ
                emit('checked', receipt)

                // SDP印刷はバックグラウンドで直列に依頼する。await しないことでチェックアウトを
                // ブロックしない。requestSdpPrint 内のトースト・再送導線は global toast 経由のため
                // Check.vue アンマウント後も機能する。
                const runSdpPrintsInBackground = async () => {
                  // eslint-disable-next-line no-restricted-syntax
                  for (const reqArgs of sdpPrintRequests) {
                    // eslint-disable-next-line no-await-in-loop
                    await requestSdpPrint(reqArgs)
                  }
                }
                runSdpPrintsInBackground()

                return
              }

              // === 従来のブラウザ直結印刷(非SDP) ===
              // 直結印刷はほぼ同期で完了し再会計の窓が一瞬のため、従来通り印刷完了後にチェックアウトする
              if (isReceiptPrinterConnected.value) {
                // 現金支払いがある会計はキャッシュドロワーを開ける(釣り銭対応のため伝票印刷より先)
                if (paymentAmounts.value.cash > 0) kickCashDrawer()

                // 並列で先行取得しているフッターの完了を保証してから印刷送信する。
                // 通常は createReceipt の完了時点で fetch も終わっており、await は即時 resolve する。
                try {
                  await footerPrefetchPromise
                } catch (e) {
                  // フッター取得失敗は致命的でないため、ログだけ残して印刷自体は試行する
                  console.error('Failed to prefetch slip footer:', e)
                }

                // printReceiptSlip / printSettlementSlip を経由すると内部で再度 fetch するため、
                // submitReceipt 経由ではプリフェッチ済みの値を使って直接 send を呼ぶ。
                if (withPrintReceiptSlip.value) {
                  if (receiptIssueMode.value === 'split' && splitRows.value.length > 0) {
                    // 分割モード: 行ごとに宛名・金額・但し書きを切替えて N枚連続印字
                    // eslint-disable-next-line no-restricted-syntax
                    for (const row of splitRows.value) {
                      // eslint-disable-next-line no-await-in-loop
                      await withRowSlipOverrides(row, () => sendReceiptSlip())
                    }
                  } else {
                    await sendReceiptSlip()
                  }
                }
                if (withPrintSettlementSlip.value) await sendSettlementSlip()
                if (withPrintDebtConfirmationPrint.value) await printDebtConfirmationSlip()
              }

              emit('checked', receipt)
            } else {
              vm.$toast.warning('問題が発生したためリダイレクトします')
              router.go(0)
            }
          }
        } catch (e) {
          if (e?.response?.status === 422) {
            // サーバ側の検証エラー(合計0など)。伝票は保存されていないのでメッセージをそのまま表示する
            const messages = e?.response?.data?.errors
            const detail = Array.isArray(messages) && messages.length > 0 ? messages.join(' / ') : ''
            vm.$toast.error(`会計を保存できませんでした${detail ? `（${detail}）` : ''}`)
          } else {
            // 保存後の印刷等で失敗した可能性もあるため、保存状態の確認を促す
            vm.$toast.error('会計処理中にエラーが発生しました。伝票が保存されているか確認してください')
          }
          console.error(e)
        } finally {
          isSubmittingReceipt.value = false
        }
      }, error => {
        console.log(error)
      })
    }

    watch(() => cloneDeep(vendingHistoriesTemp.value), (_newVal, _prevVal) => {
      // NOTE 編集対象（vendingHistoriesTemp）が変わるたびにisConfirmedはfalseへ
      isConfirmed.updateVendingHistories = false
    })

    // NOTE receiptAttributesが変わるたびにisConfirmedはfalseへ
    watch(() => cloneDeep(receiptAttributes.value), (_newVal, _prevVal) => {
      isConfirmed.submitReceipt = false
    })

    // NOTE vendingHistoriesが変わるたびに合計金額を再計算
    watch(() => cloneDeep(vendingHistories.value), (_newVal, _prevVal) => {
      refreshTotalWithCharge()
    })

    // NOTE: 売掛アコーディオンの開閉状態でbalanceReceivableAttributesを作る/空にする
    watch(() => balanceReceivableExpansionOpener.value, (newVal, _prevVal) => {
      // NOTE: 開いた時は一個つくる（保存済みのものがなければ）
      if (newVal === 0 && balanceReceivablesAttributes.value.length < 1) {
        addBalanceReceivablesAttributes({})
      }

      // NOTE: 閉じる時は全部消す（新規作成のもののみ）
      if (newVal !== 0) {
        each(balanceReceivablesAttributes.value, (obj, index) => {
          if (!obj.id) balanceReceivablesAttributes.value.splice(index, 1)
        })
      }
    })

    // NOTE: 編集時に持ってるpaymentsからpaymentAttributesをつくる
    // 元金 = 請求額 − 手数料。旧データ(支払行の手数料が全て0)は伝票の手数料を別項(legacyProcessingFee)で保持する。API は呼ばない
    watch(() => cloneDeep(props?.receipt?.attributes?.payments?.data), (newPayments, _prevPayments) => {
      if (!newPayments) return
      paymentsAttributes.value = restorePaymentRows(newPayments)
      legacyProcessingFee.value = legacyProcessingFeeOf(paymentsAttributes.value, props?.receipt?.attributes?.processingFee)

      if (paymentsAttributes.value.length === 0) {
        addPaymentAttributes({})
      }
    }, { immediate: true })

    // NOTE: 編集時に持ってるbalanceReceivablesからbalanceReceivablesAttributesをつくる
    watch(() => cloneDeep(props?.receipt?.attributes?.balanceReceivables?.data), (newBalanceReceivables, _prevBalanceReceivables) => {
      if (!newBalanceReceivables) return

      balanceReceivablesAttributes.value = []

      each(newBalanceReceivables, payment => {
        const { amount, note } = payment.attributes
        addBalanceReceivablesAttributes({ id: payment.id, amount, note })
      })
      if (balanceReceivablesAttributes.value.length > 0) balanceReceivableExpansionOpener.value = 0
    }, { immediate: true })

    // NOTE: 編集の時に値引金額をセット
    watch(() => cloneDeep(props?.receipt?.attributes?.discountFee), (newReceipt, _prevReceipt) => {
      if (!newReceipt) return

      discountFee.value = newReceipt
    }, { immediate: true })

    // NOTE: 更新後の概算を出すためにそれぞれのvendingHistoryの税サを計算
    watch(() => cloneDeep(map(vendingHistoriesTemp.value, obj => [obj.value.sellingPrice, obj.value.taxCharge])), (newVal, prevVal) => {
      if (isEqual(newVal, prevVal)) return

      each(vendingHistoriesTemp.value, vendingHistoryTemp => {
        if (vendingHistoryTemp.value.taxCharge === 'normal') {
          calcTax(vendingHistoryTemp.value.sellingPrice).then(taxPrice => {
            update(vendingHistoryTemp, 'estimatedTaxPrice', () => taxPrice)
          })
        } else {
          update(vendingHistoryTemp, 'estimatedTaxPrice', () => 0)
        }
      })
    }, { immediate: true })

    // NOTE: 概算を出すためにvendingHistory全体の大計を計算
    watch(() => cloneDeep([estimatedSubtotal.value, estimatedServiceFee.value, discountFee.value]), (newVal, prevVal) => {
      if (isEqual(newVal, prevVal)) return

      const rawEstimatedTotal = estimatedSubtotal.value + estimatedServiceFee.value

      calcTotal(rawEstimatedTotal).then(res => {
        estimatedTotal.value = Number(res) + Number(processingFee.value) - Number(discountFee.value)
      })
    }, { immediate: true })

    watch(() => isOrdering.value, (newVal, _prevVal) => {
      if (newVal) {
        if (vendingHistoriesTemp.value.length < 1) addVendingHistoryTemp({})
      } else {
        vendingHistoriesTemp.value = []
      }
    })

    // NOTE: 販売貢献人をvendingHistoryTempに自動セットするwatch
    watch(() => cloneDeep(vendingHistoriesTemp.value), (_newVal, _prevVal) => {
      setVendingContributionsAttributes({
        targetVendingHistoriesTemp: vendingHistoriesTemp.value,
      })
    })

    // NOTE: 前金分をお預かりに自動セット
    watch(() => paidInAdvanceAmount.value, (_newVal, _prevVal) => {
      if (isShow.value) return

      paymentsAttributes.value = []
      addPaymentAttributes({ baseAmount: paidInAdvanceAmount.value, paymentMethod: 'cash' })
    })

    // NOTE: ホール設定(会計手数料の自動適用可否)。親が持っていればそれを使い(フロア/ホール画面)、
    // 無ければ(データ画面経由)卓から取得する。取得できなくても会計は続行できる(自動適用しないだけ)
    const applyHallCheckoutConfig = config => {
      processingFeeAutoApplicable.value = Boolean(config?.processingFeeAutoApplicable)
    }
    if (hallCheckoutConfig?.value?.processingFeeAutoApplicable !== undefined) {
      watch(hallCheckoutConfig, applyHallCheckoutConfig, { immediate: true })
    } else {
      TableApi.getCheckoutConfig({ tableId: props.tableId })
        .then(res => applyHallCheckoutConfig(res?.data?.data?.attributes))
        .catch(() => applyHallCheckoutConfig(null))
    }

    // NOTE: init時
    if (isShow.value) {
      total.value = +props.receipt.attributes.total
      discountFee.value = +props.receipt.attributes.discountFee
      // 会計手数料は支払行(restorePaymentRows)から復元される。再表示では再計算しない

      // 会計済み表示でも税サ行にチャージを合算する(totalはreceiptの凍結値のまま)
      TableApi.calcTotal({ tableId: props.tableId, withBreakdown: true }).then(res => {
        chargeAmount.value = Number(res?.data?.chargeAmount ?? 0) || 0
        chargeName.value = res?.data?.chargeName || ''
      })
    } else {
      refreshTotalWithCharge()

      // paymentsAttributesの要素に元金がすべてセットされていたら新しく要素をつくる
      if (paymentsAttributes.value.every(payment => Number(payment.baseAmount) > 0)) {
        addPaymentAttributes({})
      }
    }

    // NOTE: 売掛金の変更
    watch(() => balanceReceivableAmount.value, newBalanceReceivableAmount => {
      if (!newBalanceReceivableAmount || newBalanceReceivableAmount <= 0) {
        withPrintDebtConfirmationPrint.value = false
      }
    })

    emit('init:reset-func', resetCheckComp)
    emit('init:edit-func', editVendingHistories)
    // /init時

    return {
      // data
      hallId,
      users,
      vendibles,
      isDrawerOpen,
      isConfirmed,
      isEditingVendingHistories,
      isSubmitting,
      isSubmittingReceipt,
      isOrdering,
      isDeleting,
      total,
      chargeAmount,
      chargeName,
      discountFee,
      processingFee,
      paymentMethods,
      paymentsAttributes,
      paymentsWithAmount,
      processingFeeAutoApplicable,
      balanceReceivablesAttributes,
      balanceReceivableExpansionOpener,
      vendingHistoriesTemp,
      vendingHistories,
      autoExtensionNoticeMinutes,
      isAutoExtensionCountdownVisible,
      withPrintSettlementSlip,
      isReceiptPrinterConnected,
      withReceiptDetails,
      withQRcode,
      receiptSlipAdvancedOptions,
      isPickingIssueDate,
      receiptNotePresets,

      // computed
      isValidToSubmit,
      isValidToCheckout,
      isTotalReady,
      totalFetchState,
      refreshTotalWithCharge,
      isShow,
      subtotal,
      serviceFee,
      paidInAdvanceAmount,
      currentTotal,
      unpaidAmount,
      totalPaymentAmount,
      change,
      estimatedSubtotal,
      estimatedServiceFee,
      estimatedTotal,
      estimatedPaidInAdvanceAmount,
      receiptAttributes,
      withPrintReceiptSlip,
      withPrintDebtConfirmationPrint,
      settlementSlipSvg,
      receiptSlipSvg,
      isSdpSlipPrintEnabled,
      slipPrintBaseOptions,
      balanceReceivableAmount,

      // methods
      removeVendingHistoryTempByIndex,
      addVendingHistoryTemp,
      editVendingHistories,
      cancelEditingVendingHistories,
      updateVendingHistories,
      createVendingHistories,
      resetVendingHistoriesTemp,
      addPaymentAttributes,
      removePaymentAttributes,
      addBalanceReceivablesAttributes,
      removeBalanceReceivablesAttributes,
      calcTotal,
      submitReceipt,
      dateTime,
      orderFromVendingHistory,
      deleteReceipt,
      isValidChange,
      printReceiptSlip,
      printSettlementSlip,
      printDebtConfirmationSlip,
      japAssReceiptPrint,
      reprintSplitRow,
      receiptIssueMode,
      splitRows,
      fractionAdjustmentHandler,
      setPaymentMethodHandler,
      setPaymentMaxHandler,
      onBaseAmountInput,
      onBaseAmountChange,
      paymentAmountOf: paymentAmount,
      formatFeeDelta,
      isCourseVendingHistory,
      // input rule
      rules,

      icons: {
        mdiPrinterPos,
        mdiPlus,
        mdiCloseCircleOutline,
        mdiCommentQuoteOutline,
        mdiTrashCanOutline,
        mdiSubdirectoryArrowRight,
        mdiQrcode,
        mdiCalendarAlert,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.v-expansion-panel::before {
  box-shadow: none !important;
}
._destroy-color {
  opacity: 0.5;
}
// 会計手数料ON行の内訳(色はVuetifyのcolor packに頼らず独自指定)
.payment-fee-note {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #7b5ea7;
  padding: 2px 4px 0;
  margin-bottom: 4px;

  &__charge {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }
}
// ダークテーマでは薄い紫と白系に切り替える
.theme--dark .payment-fee-note {
  color: #b39ddb;

  &__charge {
    color: rgba(255, 255, 255, 0.87);
  }
}
.payment-input {
  position: relative;

  ::v-deep .payment-icon {
    cursor: pointer;
    z-index: 1;
  }

  ::v-deep .append-icon {
    margin-left: 8px;
  }

  ::v-deep .prepend-icon {
    margin-right: 8px;
  }

  // disabled状態でもアイコンをクリック可能に
  ::v-deep .v-input__slot {
    .payment-icon {
      pointer-events: auto;
    }
  }
}
</style>
